import React from 'react';
import PropTypes from 'prop-types';

const DeliveryOptionsUnreachable = ({ setView }) => {
  const handleRetry = () => {
    setView('location');
  };

  return (
    <>
      <section className="do-section">
        <p className="do-question">Something went wrong</p>
        <p>
          Sorry, we were unable to reach our branches to take your click and
          collect preference. Please try again.
        </p>
      </section>
      <button
        className="ch-btn ch-btn--block ch-btn--cta ch-mb--3"
        onClick={handleRetry}
        type="button"
      >
        Try again
      </button>
    </>
  );
};

export default DeliveryOptionsUnreachable;

DeliveryOptionsUnreachable.propTypes = {
  setView: PropTypes.func,
};
